<div class="modal-header">
  <h5 class="modal-title">
    {{ mode === 'restore' ? 'Projekt wiederherstellen'
       : mode === 'patch-vegetation' ? 'Vegetation nachtragen'
       : 'Punkte importieren' }}
  </h5>
  <button type="button" class="btn-close" aria-label="Schließen" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <!-- Schritt 1: Dateiauswahl -->
  <div *ngIf="step === 'select'" class="step-content">

    <div class="file-section">
      <h6>Excel-Protokolle (Bohrpunkt / Moorpunkt)</h6>
      <p class="text-muted small">Unterstützte Formate: .xlsx, .xls, .xlsm, .xlsb</p>

      <div class="file-input-wrapper">
        <input type="file"
               id="excelInput"
               accept=".xlsx,.xls,.xlsm,.xlsb"
               multiple
               (change)="onExcelFilesSelected($event)"
               class="file-input">
        <label for="excelInput" class="btn btn-outline-primary">
          <span class="bi bi-file-earmark-excel"></span> Excel-Dateien auswählen
        </label>
      </div>

      <ul class="file-list" *ngIf="excelFiles.length > 0">
        <li *ngFor="let file of excelFiles; let i = index">
          <span class="filename">{{ file.name }}</span>
          <span class="filesize">({{ (file.size / 1024).toFixed(1) }} KB)</span>
          <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeExcelFile(i)">
            <span class="bi bi-x"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="file-section">
      <h6>GeoPackage / Shapefile</h6>
      <p class="text-muted small">Punkte mit Koordinaten und Basisattributen</p>

      <div class="file-input-wrapper">
        <input type="file"
               id="gpkgInput"
               accept=".gpkg,.shp,.geojson,.json"
               multiple
               (change)="onGpkgFilesSelected($event)"
               class="file-input">
        <label for="gpkgInput" class="btn btn-outline-secondary">
          <span class="bi bi-geo-alt"></span> Geodaten auswählen
        </label>
      </div>

      <ul class="file-list" *ngIf="gpkgFiles.length > 0">
        <li *ngFor="let file of gpkgFiles; let i = index">
          <span class="filename">{{ file.name }}</span>
          <span class="filesize">({{ (file.size / 1024).toFixed(1) }} KB)</span>
          <button type="button" class="btn btn-sm btn-link text-danger" (click)="removeGpkgFile(i)">
            <span class="bi bi-x"></span>
          </button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Schritt 1b: Layer-Auswahl für GeoPackage -->
  <div *ngIf="step === 'select-layer'" class="step-content">
    <div class="alert alert-info">
      <span class="bi bi-info-circle"></span>
      Einige GeoPackage-Dateien enthalten mehrere Punkt-Layer. Bitte wählen Sie den gewünschten Layer aus.
    </div>

    <div *ngFor="let choice of gpkgLayerChoices" class="layer-choice mb-3">
      <h6>{{ choice.file.name }}</h6>
      <select class="form-select" [(ngModel)]="choice.selectedLayer">
        <option *ngFor="let layer of choice.layers" [value]="layer">{{ layer }}</option>
      </select>
    </div>
  </div>

  <!-- Schritt 2: Analyse -->
  <div *ngIf="step === 'analyzing'" class="step-content text-center">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">Analysiere...</span>
    </div>
    <p>{{ progressText }}</p>
    <ngb-progressbar [value]="progress" [striped]="true" [animated]="true"></ngb-progressbar>
  </div>

  <!-- Schritt 3: Vorschau (Import / Patch — Restore hat eigenen Block unten) -->
  <div *ngIf="step === 'preview' && mode !== 'restore'" class="step-content">

    <!-- Patch-Vorschau (Modus „Vegetation nachtragen") -->
    <div *ngIf="mode === 'patch-vegetation'">
      <h6>Vegetations-Nachtrag (rechte Spalte)</h6>
      <p class="text-muted small mb-2">
        Match-Bereich: <strong>{{ patchProjectLabel }}</strong>
      </p>
      <div class="mb-2">
        <span class="badge bg-success me-1">{{ patchReadyCount }} bereit</span>
        <span class="badge bg-secondary me-1">{{ patchNoChangesCount }} unverändert</span>
        <span class="badge bg-warning text-dark me-1">{{ patchNoMatchCount }} kein Match</span>
        <span class="badge bg-warning text-dark me-1" *ngIf="patchMultipleCount">{{ patchMultipleCount }} mehrdeutig</span>
        <span class="badge bg-danger me-1" *ngIf="patchErrorCount">{{ patchErrorCount }} Fehler</span>
        <span class="text-muted ms-2">→ {{ patchEntriesCount }} Einträge insgesamt</span>
        <span class="text-muted ms-2" *ngIf="patchBemerkungenCleanCount > 0">
          · Bemerkungen werden bei {{ patchBemerkungenCleanCount }} Bohrpunkten bereinigt ({{ patchBemerkungenRemovedTotal }} Arten)
        </span>
      </div>

      <div class="mb-2 text-end">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveImportLog()">
          <i class="bi bi-download me-1"></i>Protokoll speichern
        </button>
      </div>

      <div class="validation-details">
        <div *ngFor="let m of patchMatches" class="sheet-result"
             [class.valid]="m.status === 'ready'"
             [class.warning]="m.status === 'multiple-matches' || m.status === 'no-match'"
             [class.error]="m.status === 'error'">
          <div class="sheet-header">
            <span class="sheet-icon">
              <span *ngIf="m.status === 'ready'" class="bi bi-check-circle-fill text-success"></span>
              <span *ngIf="m.status === 'no-changes'" class="bi bi-dash-circle text-secondary"></span>
              <span *ngIf="m.status === 'no-match' || m.status === 'multiple-matches'" class="bi bi-question-circle-fill text-warning"></span>
              <span *ngIf="m.status === 'error'" class="bi bi-x-circle-fill text-danger"></span>
            </span>
            <span class="sheet-name">{{ m.source }}</span>
            <span class="sheet-info text-muted">
              Excel-Nr.: <strong>{{ m.nummer || '(leer)' }}</strong>
              <span *ngIf="m.resolvedDoc"> → DB-Nr.: <strong>{{ m.resolvedDoc.header.nummer || '(leer)' }}</strong></span>
              — {{ m.statusMessage }}
            </span>
          </div>
          <ul class="validation-messages" *ngIf="m.status === 'ready' && (m.newEntries.length > 0 || m.cleanedBemerkungen !== undefined)">
            <li *ngFor="let e of m.newEntries" class="info">
              + <strong>{{ e.vegetation }}</strong> <span class="text-muted">({{ e.haeufigkeit || '–' }})</span>
            </li>
            <li *ngIf="m.cleanedBemerkungen !== undefined" class="info">
              <em>Bemerkungen wird um {{ m.bemerkungenRemovedCount }} Arten bereinigt</em>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Zusammenfassung (regulärer Import) -->
    <div class="validation-summary mb-3" *ngIf="mode === 'import' && validationSummary">
      <div class="row text-center">
        <div class="col">
          <div class="summary-card success"
               [class.active]="displayFilter === 'success'"
               (click)="toggleFilter('success')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.successCount }}</div>
            <div class="summary-label">Fehlerfrei</div>
          </div>
        </div>
        <div class="col">
          <div class="summary-card warning"
               [class.active]="displayFilter === 'warning'"
               (click)="toggleFilter('warning')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.warningCount }}</div>
            <div class="summary-label">Mit Warnungen</div>
          </div>
        </div>
        <div class="col">
          <div class="summary-card error"
               [class.active]="displayFilter === 'error'"
               (click)="toggleFilter('error')"
               style="cursor: pointer;">
            <div class="summary-number">{{ validationSummary.errorCount }}</div>
            <div class="summary-label">Mit Fehlern</div>
          </div>
        </div>
      </div>

      <div class="mt-2 text-end">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveImportLog()">
          <i class="bi bi-download me-1"></i>Protokoll speichern
        </button>
      </div>
    </div>

    <!-- Detaillierte Ergebnisse -->
    <div class="validation-details" *ngIf="mode === 'import'">
      <div *ngFor="let file of parsedFiles" class="file-result">
        <h6 class="file-header">{{ file.filename }}</h6>

        <div *ngFor="let sheet of file.sheets" class="sheet-result"
             [class.valid]="sheet.validation.isValid && !sheet.validation.hasWarnings"
             [class.warning]="sheet.validation.isValid && sheet.validation.hasWarnings"
             [class.error]="!sheet.validation.isValid"
             [hidden]="!sheetMatchesFilter(sheet)">

          <div class="sheet-header">
            <span class="sheet-icon">
              <span *ngIf="sheet.validation.isValid && !sheet.validation.hasWarnings" class="bi bi-check-circle-fill text-success"></span>
              <span *ngIf="sheet.validation.isValid && sheet.validation.hasWarnings" class="bi bi-exclamation-triangle-fill text-warning"></span>
              <span *ngIf="!sheet.validation.isValid" class="bi bi-x-circle-fill text-danger"></span>
            </span>
            <span class="sheet-name">Blatt {{ sheet.name }}</span>
            <span class="sheet-format badge"
                  [class.bg-primary]="sheet.format === 'bohrpunkt'"
                  [class.bg-info]="sheet.format === 'moorpunkt'"
                  [class.bg-secondary]="sheet.format === 'unknown'">
              {{ sheet.format === 'bohrpunkt' ? 'Bohrpunkt' : sheet.format === 'moorpunkt' ? 'Moorpunkt' : 'Unbekannt' }}
            </span>
            <span *ngIf="sheet.data" class="sheet-info text-muted">
              {{ sheet.data.header ? sheet.data.header.nummer || '(ohne Nummer)' : '(ohne Nummer)' }}
            </span>
          </div>

          <ul class="validation-messages" *ngIf="sheet.validation.messages.length > 0">
            <li *ngFor="let msg of sheet.validation.messages"
                [class.error]="msg.severity === 'error'"
                [class.warning]="msg.severity === 'warning'"
                [class.info]="msg.severity === 'info'">
              <strong>{{ msg.field }}:</strong> {{ msg.message }}
              <span *ngIf="msg.value" class="msg-value">(Wert: "{{ msg.value }}")</span>
              <span *ngIf="msg.suggestion" class="msg-suggestion">→ {{ msg.suggestion }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Import-Optionen -->
    <div class="import-options mt-3" *ngIf="mode === 'import'">
      <h6>Import-Optionen</h6>

      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="importValid" [(ngModel)]="importOptions.importValid">
        <label class="form-check-label" for="importValid">
          Fehlerfreie Punkte importieren ({{ validationSummary?.successCount || 0 }})
        </label>
      </div>

      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="importWarnings" [(ngModel)]="importOptions.importWithWarnings">
        <label class="form-check-label" for="importWarnings">
          Punkte mit Warnungen importieren ({{ validationSummary?.warningCount || 0 }})
        </label>
      </div>

      <div class="mt-2" *ngIf="duplicates.length > 0">
        <label class="form-label">Bei Duplikaten:</label>
        <select class="form-select form-select-sm" [(ngModel)]="importOptions.duplicateAction">
          <option value="skip">Überspringen</option>
          <option value="update" [disabled]="!canIOverwriteOnImport">
            Bestehenden Punkt aktualisieren{{ canIOverwriteOnImport ? '' : ' (nur Manager/Entwickler)' }}
          </option>
        </select>
        <div class="form-text text-muted small" *ngIf="!canIOverwriteOnImport">
          Bestehende Punkte überschreiben ist Manager/Entwicklern vorbehalten — sonst gehen Daten verloren, ohne dass es nachvollziehbar ist.
        </div>
      </div>
    </div>
  </div>

  <!-- Restore-Modus: Preview mit globaler Strategie + Per-Punkt-Checkboxen -->
  <div *ngIf="step === 'preview' && mode === 'restore'" class="step-content">

    <!-- Kontext: aus welchem Backup -->
    <p class="restore-context mb-3" *ngIf="restoreProject?.name">
      <i class="bi bi-box-seam me-1"></i>Backup: <strong>{{ restoreProject?.name }}</strong>
    </p>

    <!-- Migrations-Warnungen prominent oben -->
    <div *ngIf="restoreMigrationWarnings.length > 0"
         class="alert alert-warning small mb-3">
      <strong><i class="bi bi-exclamation-triangle me-1"></i>Hinweis Daten-Migration:</strong>
      <ul class="mb-0 mt-1">
        <li *ngFor="let w of restoreMigrationWarnings">{{ w }}</li>
      </ul>
    </div>

    <!-- Optionen-Karte: jede Auswahl als abgegrenztes Feld -->
    <div class="options-card mb-3">
      <div class="options-card-title">Wiederherstellungs-Optionen</div>

      <div class="option-field">
        <label class="option-label" for="restoreStrategySel">Standard-Aktion für Punkte</label>
        <select id="restoreStrategySel" class="form-select" [(ngModel)]="restoreStrategy" (ngModelChange)="applyRestoreStrategy()">
          <option value="overwrite-and-new">Alle erlaubten überschreiben + neue anlegen</option>
          <option value="only-new">Nur neue anlegen, vorhandene unberührt lassen</option>
        </select>
        <div class="option-hint">
          Pro Punkt mit den Haken unten feiner steuern. Blockierte Punkte sind deaktiviert.
        </div>
      </div>

      <div class="option-field">
        <label class="option-label" for="projectDataSel">Bereiche, Zeichnungen &amp; Layer</label>
        <select id="projectDataSel" class="form-select" [(ngModel)]="projectDataStrategy">
          <option value="replace">Aus Backup wiederherstellen (ersetzt vorhandene)</option>
          <option value="merge">Mit vorhandenen zusammenführen (nichts überschreiben)</option>
        </select>
        <div class="option-hint">
          Was wiederhergestellt wird, hängt von Ihrer Projektrolle ab — fehlt das Recht, wird die Kategorie übersprungen.
        </div>
      </div>
    </div>

    <!-- Punkt-Liste: Section-Header mit Zusammenfassung -->
    <div class="section-header">
      <span class="section-title">Punkte</span>
      <span class="section-summary">
        <span class="badge bg-success me-1">{{ restoreNewCount }} neu</span>
        <span class="badge bg-primary me-1">{{ restoreOverwritableCount }} überschreibbar</span>
        <span class="badge bg-secondary me-1" *ngIf="restoreBlockedCount > 0">{{ restoreBlockedCount }} blockiert</span>
        <span class="badge bg-light text-dark border ms-1">{{ restoreSelectedCount }} ausgewählt</span>
      </span>
    </div>

    <!-- Punkt-Liste mit Per-Punkt-Checkbox -->
    <div class="validation-details">
      <div *ngFor="let item of restoreItems" class="sheet-result restore-item"
           [class.valid]="item.status === 'new'"
           [class.warning]="item.status === 'overwritable'"
           [class.error]="item.status === 'blocked'">
        <div class="sheet-header">
          <input type="checkbox"
                 class="form-check-input me-2"
                 [checked]="item.selected"
                 [disabled]="item.status === 'blocked'"
                 (change)="item.selected = $any($event.target).checked">
          <span class="sheet-icon">
            <span *ngIf="item.status === 'new'" class="bi bi-plus-circle text-success"></span>
            <span *ngIf="item.status === 'overwritable'" class="bi bi-arrow-repeat text-primary"></span>
            <span *ngIf="item.status === 'blocked'" class="bi bi-lock-fill text-secondary"></span>
          </span>
          <span class="sheet-name point-ref"
                [title]="item.point.header.nummer || item.point._id">
            {{ item.point.header.nummer || item.point._id }}
          </span>
          <span class="sheet-info text-muted ms-2">
            <span *ngIf="item.status === 'new'">wird angelegt</span>
            <span *ngIf="item.status === 'overwritable'">wird überschrieben (Status: {{ item.existing?.workflow?.status || 'Bestand' }})</span>
            <span *ngIf="item.status === 'blocked'">{{ item.reason }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Restore: Erfolg -->
  <div *ngIf="step === 'complete' && mode === 'restore'" class="step-content text-center">
    <div class="complete-icon mb-3">
      <span class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></span>
    </div>
    <h5>Projekt wiederhergestellt</h5>
    <p class="text-muted">
      {{ restoredCount }} Punkte geschrieben<br>
      <span *ngIf="skippedCount > 0">{{ skippedCount }} fehlgeschlagen</span>
    </p>
    <p class="small" *ngIf="restoreDataRestored.length || restoreDataSkipped.length">
      <span *ngIf="restoreDataRestored.length" class="text-success">
        <i class="bi bi-check-circle me-1"></i>Wiederhergestellt: {{ restoreDataRestored.join(', ') }}
      </span><br *ngIf="restoreDataRestored.length && restoreDataSkipped.length">
      <span *ngIf="restoreDataSkipped.length" class="text-warning">
        <i class="bi bi-exclamation-triangle me-1"></i>Übersprungen (keine Berechtigung): {{ restoreDataSkipped.join(', ') }}
      </span>
    </p>
  </div>

  <!-- Schritt 4: Import läuft -->
  <div *ngIf="step === 'importing'" class="step-content text-center">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">Importiere...</span>
    </div>
    <p>{{ progressText }}</p>
    <ngb-progressbar [value]="progress" [striped]="true" [animated]="true"></ngb-progressbar>
  </div>

  <!-- Schritt 5: Abgeschlossen (Import / Patch — Restore hat eigenen Block oben) -->
  <div *ngIf="step === 'complete' && mode !== 'restore'" class="step-content text-center">
    <div class="complete-icon mb-3">
      <span class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></span>
    </div>
    <h5>{{ mode === 'patch-vegetation' ? 'Vegetations-Nachtrag abgeschlossen' : 'Import abgeschlossen' }}</h5>
    <p class="text-muted" *ngIf="mode === 'import'">
      {{ importedCount }} Punkte importiert<br>
      <span *ngIf="skippedCount > 0">{{ skippedCount }} übersprungen</span>
    </p>
    <p class="text-muted" *ngIf="mode === 'patch-vegetation'">
      {{ patchedCount }} Bohrpunkte ergänzt<br>
      <span *ngIf="patchSkippedCount > 0">{{ patchSkippedCount }} fehlgeschlagen</span>
    </p>
    <button type="button" class="btn btn-outline-secondary btn-sm mt-2" (click)="saveImportLog()">
      <i class="bi bi-download me-1"></i>Protokoll speichern
    </button>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()" *ngIf="step !== 'complete'">
    Abbrechen
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'select'"
          [disabled]="!hasFiles"
          (click)="startAnalysis()">
    Analysieren
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'select-layer'"
          (click)="continueAfterLayerSelection()">
    Weiter
  </button>

  <!-- Ohne geöffnetes Projekt bekämen die Punkte keine Projektzuordnung und wären
       nicht bearbeitbar — Import daher gesperrt (startImport blockiert zusätzlich). -->
  <span *ngIf="step === 'preview' && mode === 'import' && !projectService.project()"
        class="text-danger me-2">
    <i class="bi bi-exclamation-triangle me-1"></i>Kein Projekt geöffnet — bitte zuerst ein Projekt öffnen.
  </span>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'preview' && mode === 'import'"
          [disabled]="pointsToImport === 0 || !projectService.project()"
          (click)="startImport()">
    {{ pointsToImport }} Punkte importieren
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'preview' && mode === 'patch-vegetation'"
          [disabled]="patchReadyCount === 0"
          (click)="startPatchApply()">
    {{ patchReadyCount }} Bohrpunkte ergänzen ({{ patchEntriesCount }} Einträge)
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'preview' && mode === 'restore'"
          [disabled]="!restoreProject"
          (click)="applyRestore()">
    Restore starten ({{ restoreSelectedCount }} Punkte)
  </button>

  <button type="button" class="btn btn-primary"
          *ngIf="step === 'complete'"
          (click)="close()">
    Schließen
  </button>
</div>
